import { amexSvg, masterSvg, visaSvg } from "./assets/imageImport";
import { ConvertToBoolean } from "./Layout/Common/common";

export const IS_VARIANTS_ENABLED =
  typeof window.UNBXD_VARIANTS_CONFIG === "object" ? window.UNBXD_VARIANTS_CONFIG.enabled : false;

export const SEARCH_END_POINT = window.UNBXD_SEARCH_URL;
//alert(SEARCH_END_POINT);

export const VARIANT_LIMIT = 10;

export const SWATCH_MAP = {
  swatchImageUrl: "vSwatch",
  color: "color",
  size: "size",
};

export const LEFT_QUICK_MENU = [
  {
    id: "quick-order",
    label: "Quick Order",
    link: "#",
  },
  {
    id: "shop-brand",
    label: "Shop by Brands",
    link: "#",
  },
  {
    id: "new-product",
    label: "New Products",
    link: "#",
  },
  {
    id: "clearance",
    label: "Clearance Products",
    link: "#",
  },
  {
    id: "catalogue",
    label: "Catalogue eBook",
    link: "#",
  },
];

export const RIGHT_QUICK_MENU = [
  {
    id: "help",
    label: "Help",
    link: "#",
  },
  {
    id: "shop-brand",
    label: "Shop by Brands",
    link: "#",
  },
];

export const SIDE_MAINMENU = [
  {
    id: "quickorder",
    name: "Quick Order",
    class: "wes-quick-order",
    href: "#",
  },
  {
    id: "shopbybrands",
    name: "Shop by Brands",
    class: "wes-shop-brand",
    href: "#",
  },
  {
    id: "newproducts",
    name: "New Products",
    class: "wes-new-product",
    href: "#",
  },
  {
    id: "clearanceproducts",
    name: "Clearance Products",
    class: "wes-clearance",
    href: "#",
  },
  {
    id: "catalogueebook",
    name: "Catalogue eBook",
    class: "wes-catalogue",
    href: "/online-catalogue",
  },
];
export const SIDE_CONTACTMENU = [
  { id: "help", name: "Help", class: "fa-regular fa-message", href: "#" },
  { id: "contactus", name: "Contact Us", class: "wes-call", href: "#" },
];

export const ChangeOfAddressType = {
  changeOfAddress: "Change of Address",
  dropShippment: "Drop Shippment Order",
};

export const ShippingAddredKeys = [
  "shipTo",
  "shipAttention",
  "shipAddress1",
  "shipAddress2",
  "shipAddress3",
  "shipCity",
  "shipState",
  "shipZip",
  "shipCountry",
  "shipPhone",
];
export const addressLine1Keys = ["shipAddress1", "shipAddress2", "shipAddress3", "shipCity", "shipState", "shipZip"];
export const billContactLineKeys = ["billPhone"];
export const billAddressToKeys = ["billTo", "billAttention"];

export const billAddressLine1Keys = [
  "billAddress1",
  "billAddress2",
  "billAddress3",
  "billCity",
  "billState",
  "billZip",
];
export const contactLineKeys = ["shipPhone"];
export const addressToKeys = ["shipTo", "shipAttention"];

export const Message = {
  ShipMethodMailInfo:
    "Mail will be used for parcels up to 500 grams including packaging. Parcels over 500 grams will be sent by the most economical way e.g., Courier, Road, etc.",
  AerosolDangerousProduct:
    "This order contain items that are classified as dangerous goods and can only be sent by road freight. Products flagged as dangerous are: ",
  ExpressCourierNotAvailable: "Courier Express not available for product code : ",
};

export const ORDER_COMMENTS_ALERT = {
  title: "Order Comment Field Empty",
  content:
    "The selected shipping method is 'Courier Pick-Up.' Please provide the details of the courier you will arrange to collect the goods from our warehouse on your behalf in the Order Comments Field",
};

export const PONUMBER_ALLOW_DUPLICATE = {
  title: "PO Rules Violation",
  content: "Order No has been used with a previous order.",
};
export const ISPICKUPONLY_MESSAGE = "No Shipping Available for this Product. Pick Up Only";

export const PONUMBER_REQUIRED = {
  title: "PO Rules Violation",
  content: "The Purchase order number is required. Please fill it in to continue with your order.",
};

export const PAYMENT_FAILED = {
  title: "PAYMENT FAILED",
  content: "Payment Declined. Your Credit Card Declined.",
};

export const PAYMENT_GATEWAY = ["TI", "FZ", "PP"];

// Google Pay PAYMENT_GATEWAY tokenization identifier for Till. Till runs on the ixopay platform, so
// Google issues the token to "ixopay" — not to the merchant ID, and not to "tillpayments".
// The merchant ID itself comes from REACT_APP_TILL_GOOGLEPAY_MERCHANT_ID (gatewayMerchantId).
// Falls back to "ixopay" so a missing env var can't break checkout.
export const TILL_GOOGLEPAY_GATEWAY = process.env.REACT_APP_TILL_GOOGLEPAY_GATEWAY || "ixopay";

// Off unless the env explicitly says true, so a missing key hides the option rather than exposing it.
export const TILL_GPAY_ENABLED = ConvertToBoolean(process.env.REACT_APP_TILL_GPAY_ENABLED);

export const TILL_GPAY_PAYONLINE_ENABLED = ConvertToBoolean(process.env.REACT_APP_TILL_GPAY_PAYONLINE_ENABLED);

export const TILL_GPAY_PAYACCOUNT_ENABLED = ConvertToBoolean(process.env.REACT_APP_TILL_GPAY_PAYACCOUNT_ENABLED);

export const TILL_FRAME_LOAD_TIMEOUT = Number(process.env.REACT_APP_TILL_FRAME_TIMEOUT) || 12000;

// Extra origins allowed to post the Till payment result back to the checkout page. The app's own
// origin is always trusted; this covers local dev, where the API host and the CRA dev server sit on
// different ports. Must stay empty in production so only same-origin results are accepted.
export const TILL_ALLOWED_ORIGINS = (process.env.REACT_APP_TILL_ALLOWED_ORIGINS || "")
  .split(",")
  .map((origin) => origin.trim())
  .filter(Boolean);

export const NOTEMESSAGE = {
  SUBMITORDER: {
    title: "Note",
    content: ["Your Order will be submitted as a quote.", "We will get back you shortly with freight changes."],
  },
  SUMMARYSUBMITORDER: {
    title: "Note",
    content: ["Your order has been submitted as a quote. We will get back to you shortly with freight charges."],
  },
  SUMMARYCOURIERPICKUP: {
    title: "Important!",
    content: [
      "Courier Pickup service needs to be arranged by you. Please enter into the comments box located on the payment screen the courier company you will be organising to pickup your parcel and any other related details.",
    ],
  },
  SHIPPINGNOTAVAILABLE: {
    title: "Note",
    content: [" Shipping not available for item's in cart. See Cart for details."],
  },
};
export const FORGORPASSWORD = {
  INVALIDMAIL: " Please Enter Valid Email Address",
  EMPTYMAIL: "Please Enter Email Address",
};
export const RESETPASSWORD = {
  EMPTYPASSWORD: "New Password cannot be empty!",
  EMPTYCONFIRMPASSWORD: "Confirm Password cannot be empty!",
  PASSWORDNOTMATCH: "New Password and Confirm Password do not Match",
  INVALIEDPASSWORDNOT:
    "Please Enter Valid Password. Password with 8-12 characters and Must Contain mixing 1 uppercase, lowercase, numbers and symbol",
  EMPTYOLDPASSWORD: "Old Password cannot be empty!",
};
export const CHANGEUSERNAME = {
  EMPTYUSERNAME: "Enter New Login name",
  EMPTYCONFIRMUSERNAME: "Enter Confirm Login name",
  USERNAMEDNOTMATCH: "New Login name and Confirm Login name do not Match",
  EMPTYOLDUSERNAME: "Enter Old Login name",
};

export const PAYMENT_RESTRICT_ROLE = [3, 5];
export const ONACCOUNT_TERM = [2, 3, 6];
export const MASTERCARD_TERM = [4];
export const OUTSTANDING_TERM = [9];
export const BANKTRANSFER_TERM = [1, 5, 7, 8];
export const SUBMIT_ORDER = ["OA", "BT", "MC", "PAYONLINE", "CA"];
export const SHIPPING_METHOD = {
  1: "Delivery",
  2: "Counter Pickup",
  3: "Courier Pickup",
};
export const PAYMENT_METHOD_STRING = {
  OA: "On Account",
  BT: "Bank Transfer",
  PAYONLINE: "Online Payment",
  MC: "Card Payment",
};
export const BILLINFO_SHIPMETHOD = {
  COURIERPICKUP: "Customer Courier Pickup",
  COUNTERPICKUP: "Pick Up - Click and Collect from Store",
  COURIER: "Standard Shipping",
};

export const ORDER_STATUS = {
  1: "Open",
  2: "Payment",
  3: "Shipped",
  4: "Completed",
  5: "Canceled",
  6: "Order Submitted",
  7: "Manual Process",
  8: "Quote Placed",
  9: "Ready to Verify",
  10: "Custom Manual Process",
  11: "Pending",
  12: "Order Deleted",
  13: "Order Received",
  14: "Processing Order",
  15: "Payment Required",
  17: "Intl Waiting Verification",
  18: "Proforma Payment Required",
  19: "Proforma Payment Success",
  20: "Intl Order Processing",
  22: "Online Payment",
  34: "Order Ready For Pick Up",
};

export const USER_ORDER_STATUS = {
  18: "Awaiting Payment",
  14: "Order Processing",
  13: "Order Received",
  16: "Payment Completed",
  19: "Payment Completed",
  22: "Payment Completed",
  21: "Payment Completed",
  3: "Order Shipped",
  4: "Order Completed",
  34: "Order Completed with Pick Up",
  1: "Open",
  2: "Payment",
  5: "Order Canceled",
  6: "Order Submitted",
  7: "Manual Process",
  8: "Quote Placed",
  9: "Ready to Verify",
  10: "Custom Manual Process",
  11: "Pending",
  12: "Order Deleted",
  15: "Payment Required",
  17: "Intl Waiting Verification",
  20: "Intl Order Processing",
};

export const cardTypeIcon = {
  visa: visaSvg,
  masterNot: masterSvg,
  amex: amexSvg,
};

export const excludeTechnicalKeywords = ["PROD_CODE", "WagnereBook", "CROSSELL_RP"];
export const excludeSubFamilyProductKeywords = ["PROD_CODE", "Book", "book", "CROSSELL_RP"];
export const excludeAttributeColumns = ["Wes EBook", "Wagner ebook", "Description"];
export const manufacutureData = [
  { id: "aerpro", name: "Aerpro", count: 47 },
  { id: "cellink", name: "Cellink", count: 22 },
  { id: "avlabs", name: "AVLabs", count: 68 },
  { id: "benelec", name: "Benelec", count: 18 },
  { id: "bosch", name: "Bosch", count: 95 },
  { id: "cypress", name: "Cypress", count: 16 },
  { id: "daichi", name: "Daichi", count: 106 },
  { id: "dayton", name: "Dayton Audio", count: 145 },
  { id: "edifier", name: "Edifier", count: 13 },
  { id: "electro", name: "Electro-Voice", count: 82 },
  { id: "fountek", name: "Fountek", count: 3 },
  { id: "jts", name: "JTS", count: 19 },
];

export const sortbyJson = [
  { id: "sortbyRecommended", value: "Recommended" },
  { id: "sortbyNewest", value: "Newest" },
  { id: "sortbyLow", value: "Price : Low to High" },
  { id: "sortbyHigh", value: "Price : High to Low" },
  { id: "sortbyPopular", value: "Popular" },
  { id: "sortbyRelevance", value: "Relevance" },
];
export const trackingStatus = [
  { sno: 1, orderStatus: 13, statusDescription: "Order Confirmed", isCompleted: false, completedDate: null },
  { sno: 2, orderStatus: 34, statusDescription: "Courier Pick-Up", isCompleted: false, completedDate: null },
  { sno: 3, orderStatus: 3, statusDescription: "Order Shipped", isCompleted: false, completedDate: null },
  { sno: 4, orderStatus: 4, statusDescription: "Order Delivered", isCompleted: false, completedDate: null },
];
export const brandOption = [
  { id: "Apple", text: "Apple" },
  { id: "Alcatel", text: "Alcatel" },
  { id: "Asus", text: "Asus" },
  { id: "Brown", text: "Brown" },
  { id: "Blink", text: "Blink" },
  { id: "CEL FI", text: "CEL FI" },
  { id: "Dodo", text: "Dodo" },
  { id: "ERICSSon", text: "ERICSSon" },
  { id: "Google", text: "Google" },
  { id: "Sony", text: "Sony" },
  { id: "HP", text: "HP" },
  { id: "LG", text: "LG" },
];
export const modelOption = [
  { id: "iPad", text: "iPad" },
  { id: "iPad 10.2", text: "iPad 10.2" },
  { id: "iPad 2", text: "iPad 2" },
  { id: "iPad 3", text: "iPad 3" },
  { id: "iPad Air", text: "iPad Air" },
  { id: "iPad Mini", text: "iPad Mini" },
  { id: "iPad Pro", text: "iPad Pro" },
  { id: "iPad Pro 10", text: "iPad Pro 10" },
  { id: "iPhone 10", text: "iPhone 10" },
  { id: "iPhone 11", text: "iPhone 11" },
  { id: "iPhone 12", text: "iPhone 12" },
  { id: "iPhone 12 Pro", text: "iPhone 12 Pro" },
  { id: "iPhone 13", text: "iPhone 13" },
  { id: "iPhone 13 Pro", text: "iPhone 13 Pro" },
  { id: "iPhone 14", text: "iPhone 14" },
];
export const pdfTemplate = `
<html>   
<body>
   <section class="product-section" style="font-family: Arial, sans-serif;">
  <div class="container"  >
    
    <!-- Header Section -->
    <table style="width:100%; margin-bottom:20px;border-bottom: 1px solid #dddddd;padding-bottom: 10px;">
      <tr>
        <td style="width:100px;">
          <img src="https://cdn.wes.com.au/wesreact/images/logo_trans.png" alt="Berry" width="94" />
        </td>
        <td  style="width:210px;">
          <div style="font-size:23px; font-weight:bold;border-bottom: 1px solid #dddddd;">WES AUSTRALIA</div>

          <table style="width:100%; margin-top:10px;">
            <tr>
              <td style="width:25%; font-weight:bold;">Web:</td>
              <td>www.wes.com.au</td>
            </tr>
            <tr>
              <td style="width:25%; font-weight:bold;">Email:</td>
              <td>sales@wes.net.au</td>
            </tr> 
          </table>

        </td>
		
        <td  style="width:20px;"></td>
		 <td>
         
          <table style="width:100%; margin-top:10px;"> 
            <tr>
              <td style="width:25%; font-weight:bold;">Phone:</td>
              <td>+61 2 9797 9866</td>
            </tr>
            <tr>
              <td style="width:25%; font-weight:bold;">Fax:</td>
              <td>+61 2 9798 0017</td>
            </tr> 
          </table>

        </td>
 		
		<td> 
          <table style="width:100%; margin-top:10px;"> 
            <tr>
              <td style="width:25%; font-weight:bold;">Address:</td>
              <td>84-90 Parramatta Road,<br/>Summer Hill, NSW, 2130, Australia</td>
            </tr>
          </table> 
        </td>
      </tr>
    </table> 
    <table style="width:100%; margin-bottom:20px;">
      <tr>
        <td style="width:40%; vertical-align:middle;border: 1px solid #dddddd;">
          <img src="https://cdn.wes.com.au/prodimages/section16a_images/protec_images_1024/ppc-13yl_closed.jpg" style="max-width:100%;" />
        </td>
        <td style="width:60%; vertical-align:top; padding-left:20px;">
          <div style="font-size:28px; font-weight:bold;border-bottom:1px solid #dddddd;margin-bottom: 20px;padding-bottom: 12px;">PP CASE 420X327X172 YELL</div>
          <div style="margin-top:10px;">
            <div style="padding: 10px 0px;font-size: 20px;"><strong>Code:</strong> PPC-13YL</div>
            <div style="padding: 10px 0px;font-size: 20px;"><strong>Availability:</strong> <span style="color:green;">In Stock</span></div>
          </div>
          <div style="font-size:26px; color:#000; margin-top:10px;font-weight:bold">$75.00</div>

          <div style="background-color:#f82643; padding:10px; margin-top:20px; color:#fff;max-width: 460px;">
            <div style="font-weight:bold; margin-bottom:10px;text-align: center;font-size: 18px;">Pricing Details</div>
            <table style="width:100%; background-color:#fff;color:#000000" cellspacing="0">
              <tr style="font-weight:bold;color: #606060;background-color: #edeef4; font-size:16px">
                <td style="padding: 10px 20px;">Cost Ex</td>
                <td style="padding: 10px 20px;">Cost Inc</td>
                <td style="padding: 10px 20px;">Qty</td>
              </tr>
              <tr style="font-weight:bold;font-size:16px">
                <td style="padding: 10px 20px;border-right: 1px solid #f2f2f2; border-bottom: 1px solid #f2f2f2;">82.50</td>
                <td style="padding: 10px 20px; border-bottom: 1px solid #f2f2f2;">75.00</td>
                <td style="padding: 10px 20px;border-left: 1px solid #f2f2f2; border-bottom: 1px solid #f2f2f2;">1+</td>
              </tr>
              <tr style="font-weight:bold;font-size:16px">
                <td style="padding: 10px 20px;border-right: 1px solid #f2f2f2; border-bottom: 1px solid #f2f2f2;">82.50</td>
                <td style="padding: 10px 20px; border-bottom: 1px solid #f2f2f2;">75.00</td>
                <td style="padding: 10px 20px;border-left: 1px solid #f2f2f2; border-bottom: 1px solid #f2f2f2;">5+</td>
              </tr>
			   <tr style="font-weight:bold;font-size:16px">
                <td style="padding: 10px 20px;border-right: 1px solid #f2f2f2; border-bottom: 1px solid #f2f2f2;">119.90</td>
                <td style="padding: 10px 20px; border-bottom: 1px solid #f2f2f2;">109.00</td>
                <td style="padding: 10px 20px;border-left: 1px solid #f2f2f2; border-bottom: 1px solid #f2f2f2;">RRP</td>
              </tr> 
            </table>
          </div>
        </td>
      </tr>
    </table> 
    <div class="row product-specsTop">
	 <div style="font-size:28px; font-weight:bold;border-bottom:1px solid #dddddd;margin-bottom: 20px;padding-bottom: 12px;width:100%">Technical Details</div>
     <table style="width:100%;" cellspacing="30">
        <tr>
          <td style="width:50%; vertical-align:top;">
            <table style="width:100%; margin-bottom:20px;font-size:16px;border: 1px solid #dddddd;" cellpadding="20" cellspacing="0">
              <tr>
                <td style="font-weight:bold; background: #F2F3F6;  border-bottom: 1px solid #dddddd;">Manufacturer:</td>
                <td style="  border-bottom: 1px solid #dddddd;">Protec</td>
              </tr>
             <tr>
                <td style="font-weight:bold; background: #F2F3F6;  border-bottom: 1px solid #dddddd;">Manufacturer:</td>
                <td style="  border-bottom: 1px solid #dddddd;">Protec</td>
              </tr>
             <tr>
                <td style="font-weight:bold; background: #F2F3F6;  border-bottom: 1px solid#dddddd;">Manufacturer:</td>
                <td style=" border-bottom: 1px solid #dddddd;">Protec</td>
              </tr>
            </table>
          </td>
            <td style="width:50%; vertical-align:top;">
            <table style="width:100%; margin-bottom:20px;font-size:16px;border: 1px solid #dddddd;" cellpadding="20" cellspacing="0">
              <tr>
                <td style="font-weight:bold; background: #F2F3F6;  border-bottom: 1px solid #dddddd;">Manufacturer:</td>
                <td style="  border-bottom: 1px solid #dddddd;">Protec</td>
              </tr>
             <tr>
                <td style="font-weight:bold; background: #F2F3F6;  border-bottom: 1px solid #dddddd;">Manufacturer:</td>
                <td style="  border-bottom: 1px solid #dddddd;">Protec</td>
              </tr>
             <tr>
                <td style="font-weight:bold; background: #F2F3F6;  border-bottom: 1px solid#dddddd;">Manufacturer:</td>
                <td style=" border-bottom: 1px solid #dddddd;">Protec</td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>

  </div>
</section>
</body>

</html>`;

export const excludeMegaMenu = ["WESNEWS", "BRANDS", "	WES-CLR"];
export const cardValidationError = {
  number: {
    title: "Invalid Card Number",
    content: `<p class="text-center col-fs-13 fs-15 fw-normal w-100">The <b>Card number</b> you entered is incorrect. Please double-check the number and try again. Make sure there are <b>no spaces or special characters.</b></p>`,
  },
  expiryDate: {
    title: "Invalid Expiry Date",
    content: `<p class="text-center col-fs-13 fs-15 fw-normal w-100">Please check the <b>expiry date</b> you entered.  Make sure it’s in the correct format (MM/YY) and not a past date.</p>`,
  },
  cardHolder: {
    title: "Invalid Cardholder Name",
    content: `<p class="text-center col-fs-13 fs-15 fw-normal w-100">The <b>Cardholder name</b> you entered is incorrect. Please double-check the name and try again. Make sure there are <b>no special characters and no numberic.</b></p>`,
  },
  cvv: {
    title: "Invalid CVV Number",
    content: `<p class="text-center col-fs-13 fs-15 fw-normal w-100">The <b>CVV</b> you entered appears incorrect. It must be 3 or 4 digits, with no letters, spaces, or special characters.</p>`,
  },
  default: {
    title: "Invalid Details",
    content: `<p class="text-center col-fs-13 fs-15 fw-normal w-100">Some of the card details you entered are incorrect. Please check the <b>cardholder name, card number, expiry date, and CVV</b>, then try again.</p>`,
  },
  decline: {
    title: "Unable to Save Card",
    content: `<p class="text-center col-fs-13 fs-15 fw-normal w-100">3D Secure verification failed. Your transaction could not be completed. Please try again or use a different card.</p>`,
  },
};
export const getBrowserDetails = () => {
  const userAgent = navigator.userAgent;

  const getBrowserName = () => {
    if (userAgent.includes("Chrome") && !userAgent.includes("Edg") && !userAgent.includes("OPR")) {
      return "Chrome";
    } else if (userAgent.includes("Firefox")) {
      return "Firefox";
    } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
      return "Safari";
    } else if (userAgent.includes("Edg")) {
      return "Edge";
    } else if (userAgent.includes("OPR") || userAgent.includes("Opera")) {
      return "Opera";
    } else {
      return "Unknown";
    }
  };

  return {
    userAgent,
    language: navigator.language,
    platform: navigator.platform,
    screenResolution: `${window.screen.width}x${window.screen.height}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    browserName: getBrowserName(), // ✅ added browser name
  };
};
